<template>
  <v-layout
    
    align-center>
    <v-dialog
        v-model="editMenu"
        width="500"
      >
      <template v-slot:activator="{ on }">
        <v-flex>
        <v-btn
		 		  :color="strongColor"
          dark
          v-on="on"
        >	{{ groupName }} (Edit)</v-btn>
        </v-flex>
    	</template>
      <v-card>
		<!---- START TOOLBAR ---> 
        <v-toolbar
          :color="strongColor"
          flat
          dark>	
          <v-btn
            :color="strongColor"
            dark
            icon
            @click="editMenu = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ groupName }} (Edit)</v-toolbar-title>
        </v-toolbar>
    <!--- END TOOLBAR ---> 
        <v-card-text class="controls">

        <v-text-field
          :rules="[required]"
          v-model="group.name"
          label="Name"
          required
        />
        <v-text-field
          v-model="group.contactName"
          label="Contact Name"
        />
       <v-text-field
          v-model="group.addr"
          label="Address"
        />
        <v-text-field
          v-model="group.email"
          label="Email"
        />
        <v-text-field
          v-model="group.notes"
          label="Notes"
        />

       <!-- <div class="container">
          <div class="large-12 medium-12 small-12 cell">
            <label>
              File
              <input
                id="file"
                ref="file"
                type="file"
                @change="handleFileUpload()"
              >
            </label>
            <v-btn @click="create()">
              Upload File
            </v-btn> 
          </div>
        </div> -->
          
                <div
                  v-if="error"
                  class="danger-alert"
                >
                  {{ error }}
                </div>

              <v-layout row>
              <v-flex>
              <v-btn
                :color="strongColor"
                dark   
                @click="saveGroup"
              > Update Group
              </v-btn>
              </v-flex>
              <v-spacer/>
              <v-flex>
                <v-dialog 
                  v-model="deleteMenu" 
                  max-width="600">
                  <template v-slot:activator="{ on }">
                    <v-btn 
                      :color="strongColor" 
                      dark 
                      v-on="on">Delete Group
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title 
                      ma-0
                      pa-0
                      class="text-xs-center headline">
                        Delete Group?
                    </v-card-title>
                    <v-card-text 
                    pa-0
                    ma-0
                    class="text-xs-left">Are you sure that you want to delete this entire group?</v-card-text>
                    <v-card-text 
                    pa-0
                    ma-0
                    class="text-xs-left">All clients will be removed from the group, and all information about the group will be deleted if you click "Delete Group."</v-card-text>
                    <v-card-actions>
                      <v-layout 
                      justify-space-between 
                      row
                      >
                        <v-flex 
                        xs6
                        >
                        <v-btn 
                        :color="strongColor" 
                        left
                        dark
                        @click="deleteMenu = false">Cancel</v-btn>
                      </v-flex> 
                      <v-flex 
                        xs6>
                        <v-btn
                          :color="strongColor" 
                          right    
                          dark
                          @click="removeGroup">
                            Delete Group
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import GroupsService from '@/services/GroupsService'
import ClientsGroupService from '@/services/ClientsGroupService'
import { mapState } from 'vuex'
import { AVERAGE_COLOR, STRONG_COLOR, WEAK_COLOR } from '@/components/globals/consts'
export default {
  props: {
    /*groupId: {
      type: Number,
      required: true,
      default: null 
   },*/
   /*groupname: {
     type: String,
     required: true,
     default: ''
   }  */
  },
  data () {
		return {
			group: {
				name: null, // group name
				contactName: null,
				addr: null,
				phone: null,
				email: null,
        image: null,
        notes: null
      },
      file: null,
      showPreview: false,
      imagePreview: null,
      //groupId: null,
      editMenu: false,
      error: null,
      deleteMenu: false,
      strongColor: STRONG_COLOR,
			required: (value) => !!value || 'Required.'
		}
  },
  
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
      'route',
      'groupName',
      'groupId'
		])
  },
  async created () {
    //this.groupId = this.groupId
  },
	async mounted () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
		try {
      //const groupId = this.groupId
      this.group = (await GroupsService.show(this.groupId)).data
		} catch (err) {
			console.log(err)
		}
	},
	methods: {

		async removeGroup (req, res) {
			this.error = null
			/*  const areAllFieldsFilledIn = Object
        .keys(this.group)
        .every(key => !!this.group[key])
      if (!areAllFieldsFilledIn) {
        this.error = 'Please fill in all the required fields.'
        return
      } */
      this.deleteMenu = false
      this.editMenu = false
			try {
				await GroupsService.delete(this.group.id)
        //await ClientsGroupService.deleteGroup(this.group.id)

        this.$router.push({
            name: 'groups'
          })
              
      } catch (err) {
				console.log(err)
			}
    },
    handleFileUpload(){
    /*
      Set the local file variable to what the user has selected.
    */
    this.file = this.$refs.file.files[0];
    /*
      Initialize a File Reader object
    */
    let reader  = new FileReader();
    /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
    reader.addEventListener("load", function () {
      this.showPreview = true;
      this.imagePreview = reader.result;
    }.bind(this), false);

    /*
      Check to see if the file is not empty.
    */
    if( this.file ){
      /*
        Ensure the file is an image file.
      */
      if ( /\.(jpe?g|png|gif)$/i.test( this.file.name ) ) {
        /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
        reader.readAsDataURL( this.file )
        this.group.image = this.file
      }
    }
  },



		async saveGroup (req, res) {
      this.error = null
			try {
        
        this.group.name = this.group.name.trim().toLowerCase()
        console.log(this.group.name)
        await GroupsService.put(this.group)
        this.editMenu = false
        await this.$store.dispatch('setGroupName', this.group.name)

        await this.$router.push({
					name: 'group',
					params: {
						groupId: this.groupId
					}
        })
      
			} catch (err) {
				console.log(err)
			}
		}
	}
}
</script>

<style scoped>
  div.container img{
    max-width: 200px;
    max-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditGroup.vue